import { useUser } from '@/shared/providers/user-provider/use-user';
import { fetcherWithToken } from '@/shared/api/fetcher';
import useSWR from 'swr';
import { useCurrentLocale } from '@locales/client';

export const useWheels = () => {
  const { user } = useUser();
  const locale = useCurrentLocale();
  const {
    data: wheelsData,
    error: wheelsError,
    isLoading: wheelsIsLoading,
  } = useSWR(
    user.isAuth ? `/wheel?locale=${locale}&currency=${user.currency}` : null,
    fetcherWithToken
  );
  const {
    data: freeSpinsData,
    error: freeSpinsError,
    isLoading: freeSpinsIsLoading,
  } = useSWR(user.isAuth ? '/wheel/freeSpin' : null, fetcherWithToken);

  const isLoading = user.isAuth && (wheelsIsLoading || freeSpinsIsLoading);
  const error = wheelsError || freeSpinsError;

  let totalCount = 0;

  if (user.isAuth && !isLoading && !error && wheelsData && freeSpinsData) {
    const wheels: any[] = wheelsData.wheels;
    wheels.forEach((wheel) => {
      totalCount += wheel.options.count;
    });

    if (freeSpinsData.freeSpin < Date.now() / 1000) {
      totalCount += 1;
    }
  }

  return { error, isLoading, totalCount };
};
